module.exports = __webpack_public_path__ + "media/images/demo-bg-dae5d47152b758851e9a9787483ea541.png";